export default "__VITE_PUBLIC_ASSET__78f7b39c__"